import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Zone } from "../models/zone.model";

export namespace ZoneActions {

  @logDispatcher
  export class GetZones {
    static readonly type = '[Zone] GetZones';
    constructor() {}
  }

  @logDispatcher
  export class GetZonesSuccess {
    static readonly type = '[Zone] GetZonesSuccess';
    constructor(public zones: Zone[]) {}
  }

  @logDispatcher
  export class GetZonesByUserAndExercise {
    static readonly type = '[Zone] GetZonesByUserAndExercise';
    constructor(public user: string, public exerciseId: number) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Zone] Error';
    constructor(public error: any) {}
  }
}
